import React, { useEffect, useRef } from "react";

// Cloudflare Turnstile voor publieke formulieren. Rendert niets als er geen sitekey is
// (camping heeft de bot-controle uitgeschakeld of de host is niet geregistreerd).
let scriptPromise;
function loadTurnstile() {
  if (window.turnstile) return Promise.resolve();
  if (!scriptPromise) {
    scriptPromise = new Promise((resolve) => {
      const s = document.createElement("script");
      s.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
      s.async = true;
      s.onload = resolve;
      s.onerror = resolve;
      document.head.appendChild(s);
    });
  }
  return scriptPromise;
}

export function TurnstileBox({ siteKey, onToken }) {
  const ref = useRef(null);
  const idRef = useRef(null);

  useEffect(() => {
    if (!siteKey || !ref.current || idRef.current !== null) return;
    loadTurnstile().then(() => {
      if (!window.turnstile || !ref.current) return;
      idRef.current = window.turnstile.render(ref.current, {
        sitekey: siteKey,
        appearance: "interaction-only",
        theme: "auto",
        callback: (token) => onToken(token),
        "expired-callback": () => onToken(null),
      });
    });
  }, [siteKey, onToken]);

  if (!siteKey) return null;
  return <div ref={ref} data-testid="public-turnstile" className="mt-6" />;
}
